<template>
  <div class="phone-cont">
    <div class="top-img">
      <speedCom v-if="currStatus == 1" :list="list" nowType="1"></speedCom>
      <speedCom v-else :list="list" nowType="2"></speedCom>
    </div>
    <div class="phone-verify" v-if="currStatus == 1">
      <el-form :model="codeForm" :rules="codeRules" ref="codeForm" class="code-from" @submit.native.prevent>
        <el-form-item prop="phone">
          <el-input v-model="codeForm.phone" placeholder="请输入注册时的手机号" @focus="clearVerify('codeForm', 'phone')"
            :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item prop="code" class="code-item">
          <el-input v-model="codeForm.code" placeholder="请输入验证码" @focus="clearVerify('codeForm', 'code')"
            @change="codeChange" :maxlength="6"></el-input>
          <div :class="[codeBtnVal == '获取验证码' ? 'get-code' : 'get-code2']" @click="clickCode">{{ codeBtnVal }}</div>
        </el-form-item>
      </el-form>

      <div class="btn-box">
        <div class="btn" @click="findpwd" @keyup.enter="(e) => keyDown(e, 1)">下一步</div>
        <p>
          <span @click="$emit('toLogin')">返回登录</span>
        </p>
      </div>
    </div>
    <div class="pwd-reset" v-else>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdForm" class="code-from">
        <el-form-item prop="password" class="pwd-item">
          <el-input :type="passwordFlag" v-model="pwdForm.password" placeholder="数字、字母、符号(_-@&=.)组合的8-18位新密码"
            @focus="clearVerify('pwdForm', 'password')" :maxlength="18" autocomplete="new-password"></el-input>
          <i :class="[
        'open-pwd',
        passwordFlag == 'password' ? 'icon1' : 'icon2',
      ]" @click="openPwd()"></i>
        </el-form-item>
        <el-form-item prop="confirmPassword" class="pwd-item">
          <el-input :type="passwordFlag2" v-model="pwdForm.confirmPassword" placeholder="请再次输入新密码"
            @focus="clearVerify('pwdForm', 'confirmPassword')" :maxlength="18" autocomplete="new-password"></el-input>
          <i :class="[
        'open-pwd',
        passwordFlag2 == 'password' ? 'icon1' : 'icon2',
      ]" @click="openPwd2()"></i>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn" @click="login" @keyup.enter="(e) => keyDown(e, 2)">重置并登录</div>
        <p>
          <span @click="$emit('toLogin')">返回登录</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDynamicCode,
  checkCode,
  resetUserPassword,
  userLogin,
} from "@/../api";
import { zhugeTrack, jumpAfterLogin,setCookies } from "@/utils/utils";
import speedCom from "@/components/common/speed";
import { mapState, mapMutations } from "vuex";
export default {
  name: "",
  props: ["referUrl"],
  components: {
    speedCom,
  },
  data() {
    return {
      passwordFlag: "password",
      passwordFlag2: "password",
      currStatus: 1, // 1、手机验证  2、重置密码
      list: ["手机验证", "重置密码"],
      codeBtnVal: "获取验证码",
      codeErr: false,
      phoneErr: false,
      codeForm: {
        phone: "",
        code: "",
      },
      codeerrorMessage: "请输入正确验证码，连续输入错误，账号将被锁定",
      codeRules: {
        phone: [
          { validator: this.phoneValidator },
          { required: true, message: "请输入注册时的手机号", trigger: "blur" },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],

        code: [
          { validator: this.codeValidator },
          { required: true, message: "请输入动态验证码", trigger: "blur" },
          { min: 6, max: 6, message: "验证码不正确", trigger: "blur" },
        ],
      },
      pwdForm: {
        password: "",
        confirmPassword: "",
      },
      pwdRules: {
        password: [
          { required: true, message: "请输入数字、字母、符号(_-@&=.)组合的8-18位新密码", trigger: "blur" },
          {
            pattern:
              /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
            message: "必须为8-18位数字、字母、常用符号(_-@&=.)组合",
            trigger: "blur",
          },
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.confirmPwdValidator, trigger: "blur" },
        ],
      },
      nextBtnLoading: false,
      btnLoading: false,
    };
  },
  computed: {
    ...mapState(["manyloginToast", "sliderResult"]),
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  watch: {
    "sliderResult": {
      handler(val) {
        if (val) {
          this.getCode(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow", "isShowSliderVerifyHandle", "sliderResultHandle"]),
    keyDown(e) {
      if ((e.keyCode == 13 || e.keyCode == 100)) {
        if (this.currStatus == 1) {
          this.findpwd()
        } else {
          this.login()
        }
      }
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);
      const toastTimer = setTimeout(() => {
        this.toastHidden();
        clearTimeout(toastTimer)
      }, duration);
    },
    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },
    openPwd2() {
      if (this.passwordFlag2 == "password") {
        this.passwordFlag2 = "text";
      } else {
        this.passwordFlag2 = "password";
      }
    },
    // 重新输入密码校验
    confirmPwdValidator(rule, value, callback) {
      if (value != this.pwdForm.password) {
        return callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    },

    // 验证码校验
    codeValidator(rule, value, callback) {
      if (this.codeErr) {
        return callback(new Error(this.codeerrorMessage));
      } else {
        callback();
      }
    },
    phoneValidator(rule, value, callback) {
      if (this.phoneErr) {
        return callback(new Error("该用户不存在"));
      } else {
        callback();
      }
    },
    //点击验证码
    clickCode() {
      if (this.codeBtnVal != "获取验证码") return;
      this.clearVerify('codeForm', 'code')
      this.codeErr = false
      this.codeerrorMessage = ''
      if (
        !this.codeForm.phone ||
        this.codeForm.phone.length < 11 ||
        this.codeForm.phone[0] != 1
      ) {
        this.$refs["codeForm"].validateField("phone");
        return;
      }
      localStorage.setItem('currUserPhone', this.codeForm.phone)
      this.isShowSliderVerifyHandle(true)
    },
    // 获取验证码
    getCode(validCode) {
      let _this = this;
      let obj = {
        mobileOrEmail: this.codeForm.phone,
        vType: 2,
        messageType: 1,
        validCode: validCode
      };
      this.codeBtnVal = "发送中...";
      this.sliderResultHandle(false)//清空拼图操作结果
      getDynamicCode(obj).then((res) => {

        let data = res.data;
        if (data.success) {
          let num = 60;
          var timer = setInterval(() => {
            if (num <= 0) {
              _this.codeBtnVal = "获取验证码";
              clearInterval(timer);
            } else {
              _this.codeBtnVal = num-- + "s";
            }
          }, 1000);
        } else {
          if (data.code == 401) {
            this.phoneErr = true;
            this.$refs["codeForm"].validateField("phone");
            setTimeout(() => {
              this.phoneErr = false;
              this.codeForm.phone = "";
              this.$refs["codeForm"].validateField("phone");
              this.clearVerify('codeForm', 'phone')
            }, 2000)
          } else {
            this.codeerrorMessage = data.developerMsg;
            this.codeErr = true;
            this.$refs["codeForm"].validateField("code");
          }
          this.codeBtnVal = "获取验证码";
        }
      });
    },
    // 找回密码（验证验证码）
    findpwd() {

      this.$refs["codeForm"].validate((valid) => {
        if (valid) {
          if (this.nextBtnLoading) {
            return
          }
          this.nextBtnLoading = true
          let obj = {
            phone: this.codeForm.phone,
            code: this.codeForm.code,
          };
          checkCode(obj).then((res) => {
            this.nextBtnLoading = false
            let data = res.data;
            if (data.success) {
              this.currStatus = 2;

              localStorage.removeItem(this.codeForm.phone);
            } else {
              this.codeErr = true;
              this.codeerrorMessage = data.errorMessage
              this.$refs["codeForm"].validateField("code");

            }
          });
        }
      });
    },
    // 重置并登录
    login() {
      this.$refs["pwdForm"].validate((valid) => {
        if (valid) {
          let obj = {
            username: this.codeForm.phone,
            password: this.pwdForm.password,
            code: this.codeForm.code,
          };

          if (this.btnLoading) {
            return
          }
          this.btnLoading = true

          resetUserPassword(obj).then((res) => {
            let data = res.data;
            if (data.status == 200) {
              var did = zhuge.getDid();
              var sid = zhuge.getSid();
              let params = {
                userName: this.codeForm.phone,
                passWord: this.pwdForm.password,
                additional: did + "@" + sid,
                rememberMe: 1,
              };
              userLogin(params).then((res) => {
                this.btnLoading = false
                if (res.data.code == 200) {
                  localStorage.setItem('sign',res.data.data.sign)
                 setCookies('_uc_t_',res.data.data.ucToken,1)
                  // 登录成功后的跳转
                  jumpAfterLogin(this.referUrl);
                  zhugeTrack("登录成功", {
                    终端: "Web",
                    登陆方式: "忘记密码"
                  });
                } else if (res.data.code == 423) {
                  this.manyLoginToastshow();
                } else {
                  this.show("重置失败");
                }
              });
              zhugeTrack("密码重置成功", {
                终端: "Web"
              });
            } else if (data.status == 403) {
              this.show("验证已失效，请重新进行手机验证");
              setTimeout(() => {
                this.$router.push("/user/reset-pass");
              }, 3000);
              this.btnLoading = false
            } else if (data.status == 423) {
              this.btnLoading = false
              this.manyLoginToastshow();
            } else {
              this.show("重置失败");
              this.btnLoading = false
            }
          });
        }
      });
    },
    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },

    codeChange() {
      this.codeErr = false;
      this.clearVerify('codeForm', 'code')
    },
  },
};
</script>

<style lang="scss" scoped>
.phone-cont {
  padding: 42px 48px 0;
  position: relative;

  // 手机验证
  .btn-box {
    .btn {
      width: 368px;
      height: 44px;
      border-radius: 4px;
      margin-top: 33px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      letter-spacing: 0;
      cursor: pointer;
      border: none;
      outline: none;
      text-align: center;
      line-height: 44px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      background: #165dff;

      &:hover {
        background-color: #4080ff;
      }
    }

    p {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      text-align: center;
      margin-top: 44px;

      span {
        color: #4e5969;
        cursor: pointer;

        &:hover {
          color: #165dff !important;
        }
      }
    }
  }

  .speed {
    justify-content: center;
  }

  // 重置密码
  .pwd-reset {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    align-content: flex-start;

    .code-item {
      position: relative;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      ::v-deep .el-input {
        display: flex;
        width: 240px;

        .el-input__inner {
          width: 240px;
          height: 40px;
          line-height: 40px;
          border-radius: 4px;
          border: 1px solid #e5e6eb;
          overflow: hidden;
        }
      }
    }
  }


  .code-item {
    position: relative;

    ::v-deep .el-form-item__content {
      display: flex;
    }

    ::v-deep .el-input {
      display: flex;
      width: 240px;

      .el-input__inner {
        width: 240px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #e5e6eb;
      }
    }

    .get-code {
      width: 112px;
      height: 40px;
      background: #e8f3ff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      text-align: center;
      margin-left: 16px;
      cursor: pointer;

      &:hover {
        color: #165dff;
      }
    }

    .get-code2 {
      width: 112px;
      height: 40px;
      background: #e8f3ff;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      text-align: center;
      margin-left: 16px;

    }
  }

  .icon1 {
    background: url("../../assets/login/icon／preview-close\(2\).png");
    background-size: 100% 100%;
    opacity: 1;
    width: 16px;
    height: 16px;
    background-size: cover;
  }

  .icon2 {
    background: url("../../assets/login/icon／preview-open.png");
    background-size: 100% 100%;
    width: 16px;
    height: 16px;
    background-size: cover;
    opacity: 1;
  }

  .pwd-item {
    position: relative;

    .open-pwd {
      width: 14px;
      height: 14px;
      position: absolute;
      cursor: pointer;
      top: 50%;
      right: 19px;
      transform: translateY(-50%);
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }

      i {
        line-height: 14px;
      }
    }

    .icon1 {
      background: url("../../assets/login/icon／preview-close\(2\).png");
      background-size: 100% 100%;
      opacity: 1;
      width: 16px;
      height: 16px;
      background-size: cover;
    }

    .icon2 {
      background: url("../../assets/login/icon／preview-open.png");
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      background-size: cover;
      opacity: 1;
    }
  }
}
</style>
